<template>
  <div class="mr15">
    <h1 class="comm_tit01">트리 아이콘 변경하기</h1>
    <div class="comm_scr_wrap">
      <div class="row">
        <div class="col-xs-6">
          <sui-tree
            class="comp-icon-tree-item-with-icon"
            :data="rowTreeData"
            no-dots
            whole-row
            @item-click="onTreeItemClick"
          />
        </div>
        <div class="col-xs-6" v-if="selectedTreeItem">
          <sui-input-label width="120px" label="선택된 메뉴 이름"></sui-input-label>
          <input type="text" v-model="selectedTreeItem.value" class="input--text">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompIconTreeItemWithIcon", // eslint-disable-line vue/name-property-casing
  data() {
    return {
      selectedTreeItem: {}, // 선택된 TreeItem 노드
      rowTreeData: [
        {
          text: "메뉴관리",
          opened: true,
          children: [
            {
              text: "고객관리",
              opened: true,
              children: [
                {
                  text: "고객조회",
                  opened: true,
                  children: [
                    {
                      text: "고객총괄",
                    },
                    {
                      text: "고객조회"
                    },
                    {
                      text: "미승인고객조회"
                    },
                    {
                      text: "신규고객승인요청"
                    },
                    {
                      text: "관심고객"
                    },
                    {
                      text: "수금인수고객"
                    },
                    {
                      text: "VIP서비스신청"
                    }
                  ]
                },
                {
                  text: "고객사랑방문서비스"
                },
                {
                  text: "접점고객관리"
                },
                {
                  text: "이벤트고객"
                },
                {
                  text: "고객발굴"
                },
                {
                  text: "계약관리"
                },
                {
                  text: "단체등록/조회"
                }
              ]
            },
            {
              text: "활동관리",
              children: [
                {
                  text: "활동관리 세부1"
                },
                {
                  text: "활동관리 세부2"
                },
                {
                  text: "활동관리 세부3"
                }
              ]
            },
            {
              text: "상품제안",
              children: [
                {
                  text: "상품제안 세부1"
                },
                {
                  text: "상품제안 세부2"
                },
                {
                  text: "상품제안 세부3"
                }
              ]
            },
            {
              text: "상품플라자"
            },
            {
              text: "영업성과관리"
            }
          ]
        }
      ]
    };
  },
  methods: {
    onTreeItemClick(node) {
      this.selectedTreeItem = node.model;
      console.log(node);
    }
  }
};
</script>

<style>

</style>
